export default __webpack_public_path__ + "static/media/PG.8957a2a2.svg";